"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var HiddenFieldInputList = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(react_1.default.Fragment, null, store.hiddenFields.map(function (_a, idx) {
        var name = _a.name, value = _a.value;
        return (react_1.default.createElement("input", { key: idx, type: "hidden", name: name, value: value }));
    })));
});
exports.default = HiddenFieldInputList;
